import Axios from 'axios';

function getRedirectToAanvraagDetail(aanvraagId, aanbod, lang, oorsprong) {
  const params = new URLSearchParams();
  if (aanbod) {
    params.append('aanbod', aanbod);
  }
  params.append('lang', lang);
  params.append('oorsprong', oorsprong);

  return Axios.get(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v1/AanvraagDetail/${aanvraagId}/GetRedirectToAanvraagDetail`,
    {
      params
    }
  ).then(({ data }) => data);
}

export const aanvraagDetailApi = {
  getRedirectToAanvraagDetail
};
